import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { dtNL } from "@/lib/format";
import { PageHeader, Card, Badge, Th, Td, Empty } from "./ui";
import { Server, CheckCircle2, ShieldAlert, Rocket } from "lucide-react";

export default function DeployStatus() {
  const [data, setData] = useState(null);
  const [list, setList] = useState([]);
  useEffect(() => {
    api.get("/admin/deployments/current").then((r) => setData(r.data)).catch(() => {});
    api.get("/admin/deployments").then((r) => setList(r.data)).catch(() => {});
  }, []);
  const cur = data?.current;

  return (
    <div>
      <PageHeader title="Deploy status" subtitle="Alleen Soul Food City · volledig geïsoleerd van andere VPS-sites" />

      <Card className="mb-6 p-5">
        <div className="flex flex-wrap items-center gap-3">
          {data?.deploy_control_enabled ? (
            <span className="flex items-center gap-2 rounded-full bg-emerald-500/15 px-4 py-2 text-sm text-emerald-300"><Rocket size={15} /> Deploy control actief</span>
          ) : (
            <span className="flex items-center gap-2 rounded-full bg-sfc-yellow/15 px-4 py-2 text-sm text-sfc-yellow"><ShieldAlert size={15} /> Alleen-lezen — deploy control uit (DEPLOY_CONTROL_ENABLED=false)</span>
          )}
          <span className="text-xs text-white/40">Script: <code className="text-sfc-cyan">{data?.script}</code> · PM2: <code className="text-sfc-cyan">{data?.pm2_process}</code> · poort {data?.backend_port}</span>
        </div>
      </Card>

      {cur && (
        <Card className="mb-6 p-6">
          <div className="flex items-center gap-2"><Server className="text-sfc-orange" size={20} /><h3 className="font-display text-lg text-white">Huidige productieversie</h3><Badge status={cur.status === "success" ? "approved" : cur.status} /></div>
          <div className="mt-4 grid gap-x-6 gap-y-2 text-sm sm:grid-cols-2 lg:grid-cols-4">
            {[["Versie", cur.version], ["Commit", cur.commit], ["Omgeving", cur.environment], ["Branch", cur.branch], ["Door", cur.executed_by], ["Gestart", dtNL(cur.started_at)], ["Duur", `${cur.duration_seconds}s`], ["Health", cur.health_status]].map(([k, v]) => (
              <div key={k}><span className="text-white/40">{k}: </span><span className="text-white/80">{v}</span></div>
            ))}
          </div>
          <div className="mt-5 grid gap-2 sm:grid-cols-2">
            {cur.steps?.map((s, i) => (
              <div key={i} className="flex items-center justify-between rounded-lg bg-white/[0.03] px-3 py-2 text-xs">
                <span className="text-white/70">{s.step.replace(/_/g, " ")}</span>
                <span className="flex items-center gap-1 text-emerald-400"><CheckCircle2 size={13} /> {s.status}</span>
              </div>
            ))}
          </div>
        </Card>
      )}

      <Card>
        <div className="p-6 pb-3"><h3 className="font-display text-lg text-white">Deployhistorie</h3></div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="border-b border-white/10"><tr><Th>Deploy ID</Th><Th>Versie</Th><Th>Omgeving</Th><Th>Door</Th><Th>Status</Th><Th>Duur</Th><Th>Gestart</Th></tr></thead>
            <tbody>
              {list.map((d) => (
                <tr key={d.id} className="border-b border-white/5"><Td className="font-medium text-sfc-orange">{d.deploy_id}</Td><Td>{d.version}</Td><Td>{d.environment}</Td><Td className="text-white/60">{d.executed_by}</Td><Td><Badge status={d.status === "success" ? "approved" : d.status} /></Td><Td>{d.duration_seconds}s</Td><Td className="text-white/50">{dtNL(d.started_at)}</Td></tr>
              ))}
            </tbody>
          </table>
          {list.length === 0 && <Empty text="Geen deployments." />}
        </div>
      </Card>
    </div>
  );
}
